import React from 'react';

import { classnames } from '@lumapps/classnames';
import { GenericProps } from '@lumapps/lumx/react';

import './index.scss';

export interface CardProps extends GenericProps {
    /** Classname to forward on the card. */
    className?: string;
    /** Tag to use for wrapper. Default as article. */
    as?: any;
}

const SCOPE = 'page-card';

/**
 * Component displaying a simple content card with white background and padding.
 *
 * @family Cards
 * @param CardProps
 * @returns Card
 */
export const Card: React.FC<CardProps> = ({ className, children, as = 'article', ...forwardedProps }) =>
    React.createElement(
        as,
        {
            className: classnames(SCOPE, className),
            ...forwardedProps,
        },
        children,
    );

Card.displayName = 'Card';
